import { GOOGLE_ANALYTICS_IDS, YANDEX_METRIKA_IDS } from '@/shared/constants';
import type { AnalyticsGoal } from '@/shared/types';

export function reachGoal(regionCode: string, goal: AnalyticsGoal): void {
    if (typeof window === 'undefined') {
        return;
    }

    try {
        const region = regionCode.toUpperCase();

        const counterId = YANDEX_METRIKA_IDS[region];
        if (counterId) {
            window.ym?.(Number(counterId), 'reachGoal', goal);
        }

        if (GOOGLE_ANALYTICS_IDS[region]) {
            window.gtag?.('event', goal);
        }
    } catch {
        // noop
    }
}
